module.exports = __webpack_public_path__ + "static/fabric-calendar-6weeks-604f48df1241444fbb9644e645b4ab65.png";